import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-2190">
      <About data-id="element-2191" />
    </main>;
}